import { X } from 'lucide-react';
import { formatINR } from '../../utils/formatters';

export function ExpenseDrilldown({ ledger, transactions, onClose, loading }) {
  if (!ledger) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex justify-end bg-black/30 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="drill-title"
    >
      <div className="flex h-full w-full max-w-md flex-col rounded-xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
          <h2 id="drill-title" className="text-lg font-bold text-slate-900">
            {ledger}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {ledger === 'Other' && (
            <p className="text-sm text-slate-600">
              &quot;Other&quot; combines smaller categories. Select a specific category slice to see line
              items.
            </p>
          )}
          {ledger !== 'Other' && loading && <p className="text-sm text-slate-500">Loading…</p>}
          {ledger !== 'Other' &&
            !loading &&
            (!transactions || !transactions.length) && (
              <p className="text-sm text-slate-500">No transactions</p>
            )}
          <ul className="space-y-2">
            {ledger !== 'Other' &&
              (transactions || []).map((t) => (
              <li
                key={t.id}
                className="rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-sm"
              >
                <div className="flex justify-between gap-2">
                  <span className="font-medium text-slate-800">{t.narration}</span>
                  <span className="shrink-0 font-mono text-slate-700">
                    {formatINR(t.credit || t.debit)}
                  </span>
                </div>
                <div className="mt-0.5 text-xs text-slate-500">{t.date}</div>
              </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
